"use client";

import * as React from "react";
import { LifeBuoy, LogOut, Loader2 } from "lucide-react";
import { apiGet, apiPost } from "@/lib/api-client";
import type { SafeUser } from "@/types/auth";

/**
 * Thanh cảnh báo hiện xuyên suốt khi một admin đang "đăng nhập hỗ trợ" dưới danh
 * tính giáo viên. Tự lấy trạng thái qua /api/auth/me; ẩn hoàn toàn khi không hỗ trợ.
 */
export function ImpersonationBanner() {
  const [name, setName] = React.useState<string | null>(null);
  const [busy, setBusy] = React.useState(false);

  React.useEffect(() => {
    let alive = true;
    apiGet<{ user: SafeUser | null }>("/api/auth/me")
      .then((r) => {
        if (alive && r.user?.impersonatedBy) setName(r.user.fullName);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!name) return null;

  async function stop() {
    setBusy(true);
    try {
      await apiPost("/api/admin/impersonate/stop");
      window.location.href = "/quan-tri/tai-khoan-giao-vien";
    } catch {
      setBusy(false);
    }
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-500 px-4 py-2 text-center text-body-sm font-medium text-amber-950">
      <LifeBuoy className="size-4 shrink-0" aria-hidden="true" />
      <span>
        Bạn đang hỗ trợ tài khoản <strong>{name}</strong>. Mọi thao tác được thực hiện trên tài khoản giáo viên này.
      </span>
      <button
        type="button"
        onClick={stop}
        disabled={busy}
        className="inline-flex items-center gap-1 rounded-md bg-amber-950/10 px-2 py-1 font-semibold transition-colors hover:bg-amber-950/20 disabled:opacity-60"
      >
        {busy ? (
          <Loader2 className="size-3.5 animate-spin" aria-hidden="true" />
        ) : (
          <LogOut className="size-3.5" aria-hidden="true" />
        )}
        Thoát hỗ trợ
      </button>
    </div>
  );
}
